import React from 'react'
import './footer.scss'

export default function Footer(props) {
  const year = new Date().getFullYear()
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="brand">
          <h4>IngenioSoft</h4>
        </div>

        <div className="footer-bottom">
          <div>&copy; {year} IngenioSoft. Todos los derechos reservados.</div>
          <div><a href="#privacy">Política de privacidad</a> · <a href="#terms">Términos</a></div>
        </div>
      </div>
    </footer>
  )
}